export const roundUp = (num: number, decimalPlaces: number) => {
  const shiftedNum = Number(num + 'e+' + decimalPlaces);
  const roundedNum = Math.ceil(shiftedNum);
  const result = Number(roundedNum + 'e-' + decimalPlaces);

  return result;
};
